import React from "react";

// ============================================================================
// LegalShell — shared layout for public legal/commercial pages
// (Terms, Privacy, Refund, Disclaimer, Contact).
// Read-only. Static content. Loads without login.
// ============================================================================
export default function LegalShell({
  title,
  subtitle,
  lastUpdated,
  testId,
  children,
}) {
  return (
    <div className="flex flex-col gap-4 pb-2" data-testid={testId}>
      <header className="flex flex-col gap-1">
        <div className="label-up text-[10px] text-[var(--rs-text-3)]">
          RigSentinel · Legal
        </div>
        <h1 className="font-heading font-black text-2xl sm:text-3xl tracking-tight">
          {title}
        </h1>
        {subtitle && (
          <p
            className="text-xs text-[var(--rs-text-2)] leading-relaxed mt-1"
            data-testid={`${testId}-subtitle`}
          >
            {subtitle}
          </p>
        )}
        {lastUpdated && (
          <div
            className="label-up text-[10px] mt-2"
            style={{ color: "var(--rs-amber)" }}
            data-testid={`${testId}-last-updated`}
          >
            Last updated: {lastUpdated}
          </div>
        )}
      </header>
      <div className="flex flex-col gap-3">{children}</div>
    </div>
  );
}

export function LegalSection({ id, title, children, testId }) {
  return (
    <article
      id={id}
      data-testid={testId || (id ? `legal-section-${id}` : undefined)}
      className="card-rs p-4"
    >
      {title && (
        <h2 className="font-heading font-black text-base tracking-tight mb-2">
          {title}
        </h2>
      )}
      <div className="text-xs text-[var(--rs-text-2)] leading-relaxed flex flex-col gap-2">
        {children}
      </div>
    </article>
  );
}

export function LegalList({ items, testId }) {
  return (
    <ul
      className="list-disc pl-5 flex flex-col gap-1.5"
      data-testid={testId}
    >
      {items.map((item, i) => (
        <li key={i}>{item}</li>
      ))}
    </ul>
  );
}
